export default "__VITE_ASSET__063b8240__"